<template>
  <v-dialog :value="isOpenDialogExport" max-width="350" persistent>
    <v-card>
      <v-card-title class="px-8 py-4">
        <v-row dense>
          <v-col cols="12" class="d-flex justify-center">
            <span class="body-2 font-weight-medium mt-3" style="color: #2661FF">
              {{ $t("downloads.dialog1.title") }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-8 pt-4 pb-0">
        <v-row dense>
          <v-col v-if="this.moduleOptions.length > 1" cols="12">
            <v-select
              :items="moduleOptions"
              v-model="module"
              :label="$t('downloads.dialog1.module')"
              v-validate="'required'"
              :data-vv-name="$t('downloads.dialog1.module')"
              :error-messages="errors.collect($t('downloads.dialog1.module'))"
              dense
              outlined
              required
            />
          </v-col>
          <v-col v-if="module === 'Lead'" cols="12">
            <v-text-field
              v-model="email"
              :label="$t('downloads.dialog1.lead_email')"
              v-validate="'required'"
              :data-vv-name="$t('downloads.dialog1.lead_email')"
              :error-messages="
                errors.collect($t('downloads.dialog1.lead_email'))
              "
              dense
              outlined
              required
            />
          </v-col>
          <v-col cols="12">
            <v-select
              :items="fileTypes"
              v-model="fileType"
              :label="$t('downloads.dialog1.file_type')"
              v-validate="'required'"
              :data-vv-name="$t('downloads.dialog1.file_type')"
              :error-messages="
                errors.collect($t('downloads.dialog1.file_type'))
              "
              item-text="name"
              item-value="value"
              dense
              outlined
              required
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-8 pt-0 pb-4">
        <v-row dense>
          <v-col cols="6" class="d-flex justify-end">
            <v-btn
              @click="exportFile()"
              :loading="loading"
              color="#2661FF"
              small
              block
            >
              <span class="white--text">
                {{ $t("downloads.dialog1.button_export") }}
              </span>
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-flex justify-start">
            <v-btn
              @click="close()"
              :disabled="loading"
              color="#2661FF"
              outlined
              small
              block
            >
              {{ $t("general.cancel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import organizationMixin from "@/mixins/organization";
export default {
  name: "DialogExport",
  mixins: [organizationMixin],
  props: {
    moduleOptions: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: false
    },
    startTime: {
      type: String,
      required: false
    },
    endTime: {
      type: String,
      required: false
    },
    state: {
      type: Number,
      required: false
    },
    organizationName: {
      type: String,
      required: false
    },
    page: {
      type: Number,
      required: false
    },
    itemsPerPage: {
      type: Number,
      required: false
    },
    search: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      fileType: null,
      module: null,
      email: null,
      fileTypes: [
        { name: "XLSX", value: "xlsx" },
        { name: "CSV", value: "csv" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      isOpenDialogExport: "downloads/isOpenDialogExport"
    })
  },
  watch: {
    isOpenDialogExport(val) {
      if (val && this.moduleOptions.length === 1) {
        this.module = this.moduleOptions[0];
      }
    }
  },
  methods: {
    ...mapActions({
      exportData: "downloads/exportData",
      exportDataLead: "downloads/exportDataLead"
    }),
    ...mapMutations({
      toggleDialogExport: "downloads/toggleDialogExport",
      toggleDialogMessage: "downloads/toggleDialogMessage"
    }),
    async exportFile() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.submit();
      }
    },
    async submit() {
      this.loading = true;
      let res;
      if (this.module === "Lead") {
        res = await this.exportDataLead({
          type: this.fileType,
          email: this.email
        });
      } else {
        res = await this.exportData({
          type: this.fileType,
          module: this.module,
          filename: this.module,
          is_admin: true,
          start_time: this.startTime,
          end_time: this.endTime,
          filters: this.filters,
          organizationName: this.organizationName
            ? this.organizationName
            : null,
          state: this.state ? this.state : null,
          page: this.page,
          itemsPerPage: this.itemsPerPage,
          search: this.search,
          date: this.date
        });
      }
      this.loading = false;
      if (res.success) {
        this.close();
        this.toggleDialogMessage(true);
      }
    },
    close() {
      this.toggleDialogExport(false);
      this.loading = false;
      this.module = null;
      this.fileType = null;
      this.email = null;
      this.$validator.reset();
    }
  }
};
</script>
